import { render, staticRenderFns } from "./PostOrderItem.vue?vue&type=template&id=3c3605dc&scoped=true&lang=pug&"
import script from "./PostOrderItem.vue?vue&type=script&lang=js&"
export * from "./PostOrderItem.vue?vue&type=script&lang=js&"
import style0 from "./PostOrderItem.vue?vue&type=style&index=0&id=3c3605dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3605dc",
  null
  
)

/* custom blocks */
import block0 from "./PostOrderItem.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VChip,VCol,VRow,VSpacer})
